import type { IntlShape } from 'react-intl';

import type { WithdrawalCode } from '@/lib/withdrawal/types';
import { normalizeWithdrawalCode } from '@/lib/withdrawal/withdrawalCode';
import * as PM from '@/messages/payment';

export type WithdrawalSubmitApiError = {
  code?: string | null;
  message?: string | null;
};

const PRIORITIZED_CODES = [
  'LOGIN_REQUIRED',
  'WINDOW_EXPIRED',
  'DUPLICATE_REQUEST',
] as const;

function pickErrorCode(
  errors: WithdrawalSubmitApiError[],
): WithdrawalCode | undefined {
  const codes = errors
    .map((e) => normalizeWithdrawalCode(e.code))
    .filter((c): c is WithdrawalCode => c != null);
  for (const code of PRIORITIZED_CODES) {
    if (codes.includes(code)) {
      return code;
    }
  }
  return codes[0];
}

export function localizedWithdrawalSubmitErrorMessage(
  formatMessage: IntlShape['formatMessage'],
  errors: WithdrawalSubmitApiError[],
): string {
  const generic = () =>
    formatMessage(PM.paymentMessages.withdrawalGenericError);

  if (errors.length === 0) {
    return generic();
  }

  switch (pickErrorCode(errors)) {
    case 'LOGIN_REQUIRED':
      return formatMessage(PM.paymentMessages.withdrawalLoginRequired);
    case 'WINDOW_EXPIRED':
      return formatMessage(PM.paymentMessages.withdrawalWindowExpired);
    case 'DUPLICATE_REQUEST':
      return formatMessage(PM.paymentMessages.withdrawalDuplicateRequest);
    case 'NO_MATCH':
    case 'ACCESS_DENIED':
      return formatMessage(PM.paymentMessages.withdrawalOrderNotEligibleGlobal);
    case 'VALIDATION_ERROR':
    default:
      return generic();
  }
}
